// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"231":"component---src-pages-video-js","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"231":"59be3d3d5ea5e432b1d9","532":"9358739d364dae5d8443","678":"4ed7073d7911b3e0ee17","883":"08ad030942851fea14a0"}[chunkId] + ".js";
};